import React, { Component } from 'react';
import ErrorManager from '../../Core/ErrorManager';
import Merger from './../../Core/Merger';
import jQuery from 'jquery';

class Clients extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            "concerned" : [],
            "choice": null
        }

        this.node = React.createRef();

        this.merge = this.merge.bind(this);
        this.checkAll = this.checkAll.bind(this);
        this.openModal = this.openModal.bind(this);
        this.handleRadio = this.handleRadio.bind(this);

        this.page = this.props.page;
    }

    openModal(){
        this.setState({
            "choice" : null
        });
        let concerned = Array.from(this.node.current.querySelectorAll("input[type='checkbox']:checked")).map((e) => {
            if(e.id == "checkAll")
                return null;
            let c = this.props.clients[parseInt(e.value)];
            return c;
        });
        this.setState({
            "concerned" : concerned ? concerned : []
        }, () =>{
            if(this.state.concerned.length < 2)
            {
                ErrorManager.Instance.Error("Vous devez sélectionner au moins deux clients pour les fusionner.");
                return;
            }
            jQuery("#mergeChoice").modal('toggle');
        })

    }

    handleRadio(event)
    {
        this.setState({
            "choice" : event.target.value
        });
    }

    merge()
    {
        if(!this.state.choice)
        {
            ErrorManager.Instance.Error("Vous devez sélectionner une fiche principale pour fusionner les clients.");
            return;
        }
        Merger.Instance.Do(this.state.choice, this.state.concerned)
        .then((client) => {
            ErrorManager.Instance.Info("Les clients ont bien été fusionnés !");
            window.location.href = "/client/"+client.id;
        })
        .catch((error) => {
            ErrorManager.Instance.Error("Quelque chose s'est mal passé... Le développeur a été informé du problème.");
            console.error(error);
        })
    }

    checkAll(e)
    {
        let checked = e.target.checked;
        this.node.current.querySelectorAll("input[type='checkbox']").forEach((e) => {
            e.checked = checked;
        });
    }

    renderModal(){
        let index = -1;
        return (
            <div className="modal fade" id="mergeChoice" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Quelle est la fiche client principale ?</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {
                                this.state.concerned.map((e) => {
                                    if(e == null)
                                        return;
                                    index++;
                                    let identity = e.name + " " + e.first_name;
                                    return (
                                        <div className="form-group form-check" key={"formcheck-"+e.id}>
                                            <input type="radio" className="form-check-input" value={index} checked={ this.state.choice == index } id={"radio-"+e.id} key={"radio-"+e.id} onClick={ this.handleRadio } ></input>
                                            <label className="form-check-label" htmlFor={"radio-"+e.id}>{ identity }</label>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Annuler</button>
                            <button type="button" className="btn btn-primary" onClick={this.merge}>Valider</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderPagination(){
        let before = [];
        this.page = this.props.page;
        while(this.page > 0 && this.props.page - this.page < 5){
            this.page--;
            let goto = this.page;
            before.push(<li className="page-item" key={'page-item-'+(this.page+1)}><a onClick={ () => { this.props.setPage(goto) } } className="page-link" >{(this.page+1)}</a></li>);
        }

        let after = [];
        this.page = this.props.page;
        while( Math.floor(this.props.totalRows / this.props.length ) > this.page && this.page - this.props.page < 5){
            this.page++;
            let goto = this.page;
            after.push(<li className="page-item" key={'page-item-'+(this.page+1)}><a onClick={ () => { this.props.setPage(goto) }} className="page-link" >
                <div className="px-1 py-0">{(this.page+1)}</div>
                </a></li>);
        }  

        return(
            <nav aria-label="" >
                <ul className="pagination text-center justify-content-center">
                    <li className={"page-item "+(this.props.page === 0  ? "disabled" : "")}><a className="page-link" href="#" onClick={ () => this.props.setPage(0) }><span aria-hidden="true">&laquo;</span></a></li>
                    <li className={"page-item "+(this.props.page <= 0 ? "disabled" : "") }><a className="page-link" href="#" onClick={ () => this.props.setPage(this.props.page-1) }><div className="px-1 py-0">&lt;</div></a></li>
                    {before.reverse()}
                    <li className="page-item active"><a className="page-link" ><div className="px-1 py-0">{(this.props.page+1)}</div></a></li>
                    {after}
                    <li className={"page-item "+(this.props.clients.length <= 0 || Math.floor(this.props.totalRows / this.props.length) == this.props.page ? "disabled" : "")}><a onClick={ () => this.props.setPage(this.props.page+1) } className="page-link" href="#"><div className="px-1 py-0">&gt;</div></a></li>
                    <li className={"page-item "+(this.props.clients.length <= 0 || Math.floor(this.props.totalRows / this.props.length) == this.props.page ? "disabled" : "")}><a className="page-link" href="#" onClick={ () => this.props.setPage(Math.floor(this.props.totalRows / this.props.length)) }><span aria-hidden="true">&raquo;</span></a></li>
                </ul>
            </nav>
        );
    }

    render()
    {
        let clients = [];
        for(let i = 0; i < this.props.clients.length; i++)
        {
            let e = this.props.clients[i];
            if( e  == null)
                continue;
            // let postal_code = null;
            // let city = null;
            // if(e.address != null)
            // {
            //     let data = e.address.match("(.+?) ([0-9]{4,5}) (.+)");
            //     if(data != null)
            //     {
            //         postal_code = data[2];
            //         if(postal_code.length === 4)
            //             postal_code = '0'+postal_code;
            //         city = data[3];
            //     }
            // }
            clients.push(
                <tr key={ e.id } onClick={() => window.open("/client/"+e.id,'_blank')} >
                    <td className="text-center" ><input type="checkbox" value={i} onClick={(event) => event.stopPropagation()} /></td>
                    <td>{ e.name }</td>
                    <td>{ e.first_name }</td>
                    <td>{ e.phone_mobile != null ? e.phone_mobile.split(";")[0] : null }</td>
                    <td>{ e.phone != null ? e.phone.split(";")[0] : null }</td>
                    <td>{ e.email != null ? e.email.split(";")[0] : null }</td>
                    <td>{ e.postal_code }</td>
                    <td>{ e.city }</td>
                    <td>{ e.nature }</td>
                    <td>{ e.conseilor }</td>
                    <td>
                        <a className="" href={"/client/"+e.id } target="_blank" ><i className="far fa-eye"></i></a>
                    </td>
                </tr>
            );
        }
            
        return (
            <span>
                <div className="card-title">
                    <span className="h4">
                        Résultats 
                        <span className="badge badge-pill bg-green text-white ml-2">
                            { this.props.totalRows != '?' ? this.props.totalRows : <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div> }
                        </span>
                    </span>
                    <span className="float-right d-none d-md-block">
                        <a href="#" onClick={ () => this.openModal() }><li className="fas fa-code-branch"> </li> <u>Fusionner la sélection</u></a>
                    </span>
                </div>
                <div className="table-responsive mt-2">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th className="text-center">
                                    <label htmlFor="checkAll" className="mb-0" ></label> <input type="checkbox" className="align-middle" onChange={ this.checkAll } id="checkAll"  /> 
                                </th>
                                <th onClick={ () => { this.props.sort("name") }}>Nom</th>
                                <th onClick={ () => { this.props.sort("first_name") }}>Prénom</th>
                                <th onClick={ () => { this.props.sort("Client.phone_mobile") }}>Téléphone mobile</th>
                                <th onClick={ () => { this.props.sort("phone") }}>Téléphone fixe</th>
                                <th onClick={ () => { this.props.sort("email") }}>Email</th>
                                <th onClick={ () => { this.props.sort("postal_code") }}>Code Postal</th>
                                <th onClick={ () => { this.props.sort("city") }}>Ville</th>
                                <th onClick={ () => { this.props.sort("nature") }}>Dernière relation client</th>
                                <th onClick={ () => { this.props.sort("conseilor") }}>Conseiller</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody ref={ this.node }>
                            { clients }
                        </tbody>
                    </table>
                    {this.renderPagination()}
                    {this.renderModal()}
                </div>
            </span>
        );
    }
}

export default Clients;


// WEBPACK FOOTER //
// ./src/Components/Client/Clients.js